
export class ReturnStatus{
    status: boolean = true;
    innerDescription: string =" ";
    returnObject: any;
    description: string =" ";


    constructor(status?:boolean, description?: string, innerdescription?: string, returnobject?: any){

        if(status==undefined){
            this.status=true;
            return;
        }

        this.status=status;
        this.description=description;
        this.innerDescription=innerdescription;
        this.returnObject=returnobject;

    }
}
